/**
 * Selection set for the `meta` group that the API's `seoPlugin` adds to the
 * `articles`, `magazines` and `pages` collections.
 *
 * A plain string rather than a `gql` fragment on purpose: Payload generates a
 * separate type per collection (`Article_Meta`, `Magazine_Meta`, `Page_Meta`),
 * and a GraphQL fragment has to name exactly one type - so sharing one fragment
 * across the three queries is impossible. Interpolating a raw string into a
 * `gql` template concatenates it into the document source before parsing, which
 * gives us the same reuse without three near-identical fragments.
 */
export const SEO_META_FIELDS = `
  meta {
    title
    description
    image {
      url
      width
      height
      mimeType
    }
  }
`
